<template>
  <div class="row" style="margin:0px;">
      <div class="offset-md-1 col-md-10" style="padding-top:4vh;">
        <p class="search_title">{{searchprojects.length}} Total Projects
          <span style="float:right"><a @click="BacktoHome()"><md-icon class="close-btn" >close</md-icon></a></span>
        </p>
        <div style="margin-top:4vh;">
          <md-field class="search_content">
            <md-icon style="color:#346168 !important">search</md-icon>
            <md-input  v-model="searchP" placeholder="Search..."></md-input>
          </md-field>
          <!--<md-autocomplete
				          class="search_content"
				          v-model="searchP"
				          :md-options="employees"
				          md-layout="box">
				          <label><md-icon style="color:#346168 !important">search</md-icon>&nbsp;<span>Search...</span></label>
				  </md-autocomplete>-->
        </div>
      </div>
      <div class="offset-md-1 col-md-10" id="style-4" style="max-height:80vh;overflow:auto;margin-top:4vh">
        <div class="row" style="margin-bottom:20vh;">
          <div class="col-md-4" :key="index" v-for="(p, index) in searchedProjects" style="margin-bottom:20px;padding-right:0px;">
          <div  class="newclass card h-100" @click="sortProjects(p.APItoken)">
            <div class="card-body" style="margin:2px;text-align:left;padding:0.75rem">
              <span class="p_name">{{p.API_title}}</span>
              <hr>
              <div class="Recent-Activity">Recent Activity</div>
              <div class="act" v-if="p.Unread_discussions == 0">No Activites Found.</div>
              <div class="act" v-if="p.Unread_discussions > 0" style="color:red">
                <b>{{p.Unread_discussions}}</b>  New <span v-if="p.Unread_discussions == 1">Activity.</span><span v-else>Activites.</span>
              </div>
            </div> 
           
          </div>
          </div>
        </div>
      </div>
	</div>
</template>

<script>
    import Vue from 'vue'
    import { EventBus } from '../event-bus.js'
    
	export default {
        name: 'SearchProject',
	    data () {
	      return {
	        selectedEmployee: '',
            employees: [],
            searchP : "",
	      }
        },
        props : ['searchprojects'],
        computed: {
            sortbyNotifications(){
              this.searchprojects.sort(function(a, b) {
                  return b.Unread_discussions - a.Unread_discussions;
              });
              return this.searchprojects
            },
            searchedProjects() {
                if(this.sortbyNotifications == undefined){
                    return []
                }
                return this.sortbyNotifications.filter(post => {
                    if(post.API_title != ""){
                        return post.API_title.toLowerCase().includes(this.searchP.toLowerCase())
                    }else{
                        return post.Project_name.toLowerCase().includes(this.searchP.toLowerCase())
                    }
                })
            },
        },
        methods: {
            BacktoHome () {
                EventBus.$emit('closeSearch', "pp")
            },
            sortProjects(apitoken){
                 EventBus.$emit('sortProject', apitoken)
            },
        }
    }
</script>

<style scoped>
  .newclass{
    margin-right:2px;
    margin-left:2px;
    padding: .15rem;
    cursor: pointer;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #dedede;
    background-color: #ffffff !important;
  }
.Recent-Activity {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  color: #474747;
}
.act{
  margin-bottom:1vh;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.89;
  letter-spacing: normal;
  text-align: left;
  color: #232323;
}
.view{
  position: absolute;
  bottom:10px !important;
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  color: #529da3;
}
.p_name{
    font-size: 1.8vh;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.88;
    letter-spacing: normal;
    text-align: left;
    color: #398d8d;
}
.close-word{
    font-family: Lato;
    font-size: 1.6vh;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #006871;
    text-transform: uppercase;
}
.close-btn {
  color: #319fa5 !important;
  font-size:3vh !important;
}
.search_toolbar {
  background-color: #e6efee !important;
}
.md-toolbar .md-autocomplete.md-theme-default.md-autocomplete-box label{
    color: #333333 !important;
}
.search_title {
    font-family: Lato;
    font-size: 2.6vh;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.98;
    letter-spacing: normal;
    text-align: left;
    color: #333333;
}
.search_content {
  margin-bottom: 2vh !important;
  border: solid 1px #d6e3e2 !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
  border-radius: 11px !important;
  padding:1.5vh !important;
  padding-left:3vh !important;
}
.recently_search {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  color: #474747;
  margin-left: 10vh;
  margin-top: 5vh
}
.md-field:after, .md-field:before{
  transition: none !important;
  display: none !important;
}

</style>
